import { Icon } from '@nazka/nazka.mapframe.components';

import { useTranslation } from '@utils/i18n/i18n.consumers';
import { RISK_COLORS } from '@App/pages/RiskDataPage/risk-data-page.constants';

import './collapsible-trigger.styl';

function CollapsibleTrigger({
  open,
  icon,
  title,
  riskValue,
}) {
  const { t } = useTranslation();
  
  const riskColor = RISK_COLORS[riskValue] || '#999';

  return (
    <div className={`collapsible-trigger${open ? ' collapsible-trigger--open' : ''}`}>
      <div className="collapsible-trigger__header">
        <div className="collapsible-trigger__header__title">
          <Icon icon={icon} size="24px" />
          {title}
        </div>

        <div className="collapsible-trigger__header__risk" style={{ backgroundColor: riskColor }}>
          {t('{{riskValue}} Risk', { riskValue: t(riskValue) }) || t('Unknown')}
        </div>
      </div>
    </div>
  );
}

export default CollapsibleTrigger;